import { type Page } from './constants';
import createErrors from '../createErrors';

export type Component = 'CreateAccount';

/**
 * Errors related to the Create Account page
 */
export const Errors = createErrors<Page, Component>('CreateAccount')({
    CreateAccount: {
        SubmitFailed: {
            severity: 'HIGH',
            message: 'Failed to submit create account form',
        },
        HandleAccessFailed: {
            severity: 'HIGH',
            message: 'Failed to handle access',
        },
        TrackSubmitValidationErrorsFailed: {
            severity: 'HIGH',
            message: 'Failed to track submit validation errors',
        },
        IsAOSAgentTriggerResetFailed: {
            severity: 'HIGH',
            message: 'Failed to trigger reset password for AOS agent',
        },
    },
});
